import React, { useState, useCallback } from 'react';
import { css } from 'emotion';
import { ElementRoot } from '@whalecloud/page-builder-core/components/ElementRoot';
import { Steps as DesignSteps } from '@whalecloud/fdx';
import FormItem from "@whalecloud/page-builder-core/components/Render/components/FormItem";
import { makeEventProps } from '@whalecloud/page-builder-core/utils/common';
import Element from "@whalecloud/page-builder-core/components/Render/components/Element";

const { Step } = DesignSteps;

const Steps = props => {
  const { element, nameSpace, ...otherProps } = props;
  const { data: { formItemSettings = {}, formSettings = {}, settings = {}, className = '' } } = element;
  const { visible } = settings;
  const { steps = [], defaultActiveKey, ...restProps } = formItemSettings;

  const [activeKey, setActiveKey] = useState();
  const eventProps = makeEventProps(element.data.events, nameSpace);

  const handleChange = activeKey => {
    setActiveKey(activeKey);
    eventProps.onChange && eventProps.onChange(activeKey);
  }
  
  return (
    <ElementRoot className={'webiny-pb-base-page-element-style'} element={element}>
      {({ getAllClasses, elementStyle }) => (
        <div>
          <FormItem
            id={element.id}
            style={{
              ...elementStyle,
              visibility: visible
            }}
            {...formSettings}
          >
            <DesignSteps current={activeKey} onChange={handleChange} {...restProps}>
              {steps.map((child, i) => (
                  <Step status={child.status} title={child.title} description={child.description} />
                ))
              }
            </DesignSteps>
          </FormItem>
        </div>
      )}
    </ElementRoot>
  );
};

export default Steps;
